import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CitiesTableHeader = ({ 
  sortField, 
  sortDirection, 
  onSort, 
  selectedCount, 
  totalCount, 
  onSelectAll,
  currentLanguage = 'ar' 
}) => {
  const handleSort = (field) => {
    const newDirection = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
    onSort(field, newDirection);
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return 'ArrowUpDown';
    return sortDirection === 'asc' ? 'ArrowUp' : 'ArrowDown';
  };

  const isAllSelected = selectedCount === totalCount && totalCount > 0;
  const isPartiallySelected = selectedCount > 0 && selectedCount < totalCount;

  return (
    <thead className="bg-muted/50 border-b border-border">
      <tr>
        {/* Select All Checkbox */}
        <th className="w-12 px-4 py-3">
          <div className="relative">
            <input
              type="checkbox"
              checked={isAllSelected}
              ref={(input) => {
                if (input) input.indeterminate = isPartiallySelected;
              }}
              onChange={(e) => onSelectAll(e?.target?.checked)}
              className="w-4 h-4 text-primary bg-background border-border rounded focus:ring-primary focus:ring-2"
            />
          </div>
        </th>

        {/* City Name */}
        <th className="px-4 py-3 text-right">
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 font-semibold text-foreground hover:text-primary"
            onClick={() => handleSort('name')}
          >
            <div className="flex items-center space-x-2">
              <span>اسم المدينة</span>
              <Icon 
                name={getSortIcon('name')} 
                size={14} 
                className={sortField === 'name' ? 'text-primary' : 'text-muted-foreground'} 
              />
            </div>
          </Button>
        </th>

        {/* Sub-Union Count */}
        <th className="px-4 py-3 text-right">
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 font-semibold text-foreground hover:text-primary"
            onClick={() => handleSort('subUnionCount')}
          >
            <div className="flex items-center space-x-2">
              <span>الاتحادات الفرعية</span>
              <Icon 
                name={getSortIcon('subUnionCount')} 
                size={14} 
                className={sortField === 'subUnionCount' ? 'text-primary' : 'text-muted-foreground'} 
              />
            </div>
          </Button>
        </th>

        {/* Coordinates */}
        <th className="px-4 py-3 text-right">
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 font-semibold text-foreground hover:text-primary"
            onClick={() => handleSort('coordinates')}
          >
            <div className="flex items-center space-x-2">
              <span>الإحداثيات</span>
              <Icon 
                name={getSortIcon('coordinates')} 
                size={14} 
                className={sortField === 'coordinates' ? 'text-primary' : 'text-muted-foreground'} 
              />
            </div>
          </Button>
        </th>

        {/* Status */}
        <th className="px-4 py-3 text-right">
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 font-semibold text-foreground hover:text-primary"
            onClick={() => handleSort('status')}
          >
            <div className="flex items-center space-x-2">
              <span>الحالة</span>
              <Icon 
                name={getSortIcon('status')} 
                size={14} 
                className={sortField === 'status' ? 'text-primary' : 'text-muted-foreground'} 
              />
            </div>
          </Button>
        </th>

        {/* Created Date */}
        <th className="px-4 py-3 text-right">
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 font-semibold text-foreground hover:text-primary"
            onClick={() => handleSort('createdAt')}
          >
            <div className="flex items-center space-x-2">
              <span>تاريخ الإنشاء</span>
              <Icon 
                name={getSortIcon('createdAt')} 
                size={14} 
                className={sortField === 'createdAt' ? 'text-primary' : 'text-muted-foreground'} 
              />
            </div>
          </Button>
        </th>

        {/* Actions */}
        <th className="px-4 py-3 text-right">
          <span className="text-sm font-semibold text-foreground">الإجراءات</span>
        </th>
      </tr>
    </thead>
  );
};

export default CitiesTableHeader;